class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (this.mainDetailsToggle.hasAttribute('data-keep-open')) {
      this.mainDetailsToggle.setAttribute('open', true);
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      return;
    }
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopHoverMediaQuery = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
    this.hoverCloseTimeout = null;
    this.submenu = document.querySelector('desktop-submenu')
    this.mask = this.content?.querySelector('.submenu-mask');
    this.onDesktopHoverIn = this.handleDesktopHoverIn.bind(this);
    this.onDesktopHoverOut = this.handleDesktopHoverOut.bind(this);
    this.onSummaryMouseLeave = this.handleSummaryMouseLeave.bind(this);
    this.onMaskMouseEnter = this.handleMaskMouseEnter.bind(this);
    this.mainDetailsToggle.addEventListener('mouseenter', this.onDesktopHoverIn);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onDesktopHoverOut);
    this.summary.addEventListener('mouseleave', this.onSummaryMouseLeave);
    this.mask?.addEventListener('mouseenter', this.onMaskMouseEnter);

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.onToggle();
    }
  }

  onToggle() {
    if (this.mainDetailsToggle.hasAttribute('data-keep-open') && !this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', true);
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  handleDesktopHoverIn() {
    if (!this.desktopHoverMediaQuery.matches) return;
    if (this.hoverCloseTimeout) {
      clearTimeout(this.hoverCloseTimeout);
      this.hoverCloseTimeout = null;
    }
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  handleDesktopHoverOut(event) {
    if (!this.desktopHoverMediaQuery.matches) return;
    if (this.mainDetailsToggle.hasAttribute('data-keep-open')) return;
    const relatedTarget = event?.relatedTarget;
    if (relatedTarget instanceof Node && this.mainDetailsToggle.contains(relatedTarget)) return;

    this.hoverCloseTimeout = setTimeout(() => {
      if (this.mainDetailsToggle.matches(':hover')) return;
      this.close();
      this.hoverCloseTimeout = null;
    }, 180);
  }

  handleSummaryMouseLeave(event) {
    this.handleDesktopHoverOut(event);
  }

  handleMaskMouseEnter() {
    if (!this.desktopHoverMediaQuery.matches) return;
    this.close();
  }

  disconnectedCallback() {
    if (this.hoverCloseTimeout) {
      clearTimeout(this.hoverCloseTimeout);
      this.hoverCloseTimeout = null;
    }
    this.mainDetailsToggle.removeEventListener('mouseenter', this.onDesktopHoverIn);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onDesktopHoverOut);
    this.summary.removeEventListener('mouseleave', this.onSummaryMouseLeave);
    this.mask?.removeEventListener('mouseenter', this.onMaskMouseEnter);
  }
}

customElements.define('header-menu', HeaderMenu);
